const phone = '01 277 2365'
const email = 'thejforcehelp@jumia.com.ng'
const supportedLanguages = ['en']
const personalInfo = {
  phoneNumberMask: '#### ### ####'
}
const paymentMethods = {
  bankAccountMask: '### ### ####'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
